import script from "./IsDark.vue?vue&type=script&setup=true&lang=js"
export * from "./IsDark.vue?vue&type=script&setup=true&lang=js"

import "./IsDark.vue?vue&type=style&index=0&id=42acbce2&lang=css"

const __exports__ = script;

export default __exports__